import { RootState } from '@/store/main';

export const getRegistrationQuestions = (state: RootState) => state.channel.registrationQuestions;
